import { render, staticRenderFns } from "./Messenger.vue?vue&type=template&id=06fda0a8&scoped=true"
import script from "./Messenger.vue?vue&type=script&lang=js"
export * from "./Messenger.vue?vue&type=script&lang=js"
import style0 from "./Messenger.vue?vue&type=style&index=0&id=06fda0a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fda0a8",
  null
  
)

export default component.exports